<template>
  <div class="w-full flex flex-col items-center justify-center">
    <div class="w-full h-12 hidden sm:flex"></div>
    <div class="card flex flex-col bg-white rounded max-w-sm w-full">
      <div class="flex flex-col w-full space-y-2">

        <button class="nxp-back-btn hidden sm:flex" @click="handleBackward">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <mask id="mask0_857_10485" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16"
              height="16">
              <rect width="16" height="16" fill="#696969" />
            </mask>
            <g mask="url(#mask0_857_10485)">
              <path
                d="M9.33362 11.7688L5.56445 7.99964L9.33362 4.23047L10.0361 4.93297L6.96945 7.99964L10.0361 11.0663L9.33362 11.7688Z"
                fill="#A9A9A9" />
            </g>
          </svg>
          Voltar
        </button>
        <span v-if="jobPositionReference" class="nxp-job-title">
          {{ jobPositionReference }}
        </span>
        <h1 class="nxp-title-form">
          Informe seu endereço
        </h1>
        <span class="nxp-subtitle-form">
          Ao inserir seu endereço encontraremos vagas mais próximas de sua residência
        </span>
      </div>


      <ValidationObserver ref="addressForm" class="flex flex-column flex-wrap" tag="form" @submit.prevent="handleForward()"
        v-slot="{ invalid }">
        <div class="w-full flex flex-col space-y-4 mt-12">

          <div class="w-full flex flex-col space-y-2">
            <div class="flex flex-col space-y-2">

              <div class="flex items-center gap-1">
                <label for="pronouns" class="nxp-label">CEP</label>
              </div>
              <span class="nxp-sublabel">
                Só numeros
              </span>
            </div>
            <ValidationProvider name="cep" rules="min:9" v-slot="{ errors }">
              <vs-input 
                class="no-icon-border mb-5 w-32" 
                v-mask="'#####-###'" 
                placeholder="______-___" 
                name="postalcode" 
                type="text" 
                :floating-label="true"
                v-model="payload.postalcode" 
                @blur="searchCEP"
              />
              <span class="text-danger" v-if="errors.length">CEP deve estar no formato 00000-000</span>
            </ValidationProvider>
          </div>


          <div class="w-full flex flex-col space-y-2">
            <div class="flex flex-col space-y-2">

              <div class="flex items-center gap-1">
                <label for="país" class="nxp-label">País</label>
              </div>
            </div>

            <ValidationProvider name="país" rules="required" v-slot="{ errors }">
              <v-select class="w-full no-icon-border mb-3" v-model="payload.country" :options="countryOptions" :reduce="country => country.value">
                <template #search="{ attributes, events }">
                  <input class="vs__search" :required="!payload.country" v-bind="attributes" v-on="events" />
                </template>
                <template #no-options="{ search }">
                  <div>Nenhum país encontrado com "{{ search }}"</div>
                </template>
              </v-select>
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="w-full flex flex-col space-y-2">
            <div class="flex flex-col space-y-2">

              <div class="flex items-center gap-1">
                <label for="estado" class="nxp-label">Estado</label>
              </div>
            </div>

            <ValidationProvider v-if="payload.country.toLowerCase() === 'brasil'" name="estado" rules="required"
              v-slot="{ errors }">
              <v-select class="mb-1" v-model="payload.state" :options="ufOptions" :reduce="uf => uf.value" @input="value => calculateProgress({ field: 'state', value })">
                <template #search="{ attributes, events }">
                  <input class="vs__search" :required="!payload.state" v-bind="attributes" v-on="events" />
                </template>
                <template #no-options="{ search }">
                  <div>Nenhum estado encontrado com "{{ search }}"</div>
                </template>
              </v-select>
              <span class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
            <ValidationProvider v-else-if="
              payload.country.length > 0 &&
              payload.country.toLowerCase() !== 'brasil'
            " name="estado" rules="required" v-slot="{ errors }">
              <vs-input class="mb-1 w-full" v-model="payload.state" :danger="errors.length > 0"
                :danger-text="errors[0] || ''" />
            </ValidationProvider>
            <vs-input v-else class="mb-1 w-full" v-model="payload.state" />
          </div>

          <div class="w-full flex flex-col space-y-2">
            <div class="flex flex-col space-y-2">

              <div class="flex items-center gap-1">
                <label for="city" class="nxp-label">Cidade</label>
              </div>
            </div>
            <ValidationProvider v-if="payload.country.toLowerCase() === 'brasil'" name="cidade" rules="required"
              v-slot="{ errors }">
              <v-select class="mb-1" name="city" v-model="payload.city" :options="cityOptions"
                :reduce="city => city.value" @input="value => calculateProgress({ field: 'state', value })">
                <template #search="{ attributes, events }">
                  <input class="vs__search" :required="!payload.city" v-bind="attributes" v-on="events" />
                </template>
                <template #no-options="{ search }">
                  <div>Nenhuma cidade encontrada com "{{ search }}"</div>
                </template>
              </v-select>
              <span class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
            <ValidationProvider v-else-if="
              payload.country.length > 0 &&
              payload.country.toLowerCase() !== 'brasil'
            " name="cidade" rules="required" v-slot="{ errors }">
              <vs-input class="mb-1 w-full" v-model="payload.city" :danger="errors.length > 0"
                :danger-text="errors[0] || ''" />
            </ValidationProvider>
            <vs-input v-else class="mb-1 w-full" v-model="payload.city" />
          </div>

        </div>
      </ValidationObserver>


      <button class="nxp-continue-btn mt-16" :style="{ background: color }" @click="handleForward">
        {{
          isEdit() ?
            "Salvar" :
            'Continuar'
        }}
      </button>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import { ModelSelect } from "vue-search-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import ForwardButton from "@/components/ForwardButton";
import BackwardButton from "@/components/BackwardButton";
import { countries } from "@/utils/countries";

export default {
  data: () => ({
    payload: {
      city: "",
      state: "",
      address: "",
      country: "",
      postalcode: "",
      autocomplete: false,
      address_number: "",
      address_complement: "",
      address_neighborhood: ""
    },
    ufOptions: [],
    cityOptions: [],
    jobPositionReference: localStorage.getItem("vacancy_name"),
    countryOptions: countries.map(country => ({
          label: country.nome_pais,
          value: country.nome_pais
        })),
  }),
  computed: {
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    },
  },
  watch: {
    "payload.postalcode"(value) {
      if (value === "") {
        this.payload = {
          ...this.payload,
          autocomplete: false
        };
      }
    },
    "payload.country"(country) {
      const countryCapitalize =
        country.charAt(0).toUpperCase() + country.slice(1);

      this.payload = {
        ...this.payload,
        country: countryCapitalize
      };

      if (country.toLowerCase() === "brasil") {
        axios
          .get("https://servicodados.ibge.gov.br/api/v1/localidades/estados")
          .then(response => {
            this.ufOptions = response.data.map(uf => ({
              label: uf.nome,
              value: uf.sigla
            }));
          });
      }
    },
    "payload.state"(uf) {
      if (uf !== "" && this.payload.country.toLowerCase() === "brasil") {
        axios
          .get(
            `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
          )
          .then(response => {
            this.cityOptions = response.data.map(city => ({
              label: city.nome,
              value: city.nome
            }));

            const cidadeExiste = this.cityOptions.some(city => city.value === this.payload.city);
            if (!cidadeExiste) {
              this.payload.city = "";
            }
          });
      }
    },
    "payload.city"(city) {
      const cityCapitalize = city.charAt(0).toUpperCase() + city.slice(1);

      this.payload = {
        ...this.payload,
        city: cityCapitalize
      };
    }
  },
  created() {
    window.scroll(0, 0);

    this.fetchAddress();

    axios
      .get("https://servicodados.ibge.gov.br/api/v1/localidades/estados")
      .then(response => {
        this.ufOptions = response.data.map(uf => ({
          label: uf.nome,
          value: uf.sigla
        }));
      });

    this.googleAnalytics();
  },
  methods: {
    isEdit() {
      return this.$router.history.current.path.includes('edit')
    },
    countryIsFilled() {
      setTimeout(() => {
        return this.payload.country !== "";
      }, 3000);
    },

    validate() {
      const validate = Object.keys(this.payload)
        .filter(key => typeof this.payload[key] === "string")
        .filter(key => this.payload[key] !== "");

      if (this.payload.state) {
        return validate.includes("country") &&
          validate.includes("state") &&
          validate.includes("city");
      }

      return validate.includes("country");
    },
    async handleBackward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail"
        });
        return;
      }

      await this.$store.dispatch("step/decrementCurrentStep");

      const { path } = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: path,
        params
      });
    },

    async handleForward() {
      const isValid = await this.$refs.addressForm.validate();
      if (isValid) {
        this.$vs.loading({ text: "Enviando..." });
        const { company_label } = this.$router.history.current.params;

        this.$http
          .post(`api/v1/talent/${company_label}/user/talent?step=address`, {
            address: {
              ...this.payload
            }
          })
          .then(async response => {
            this.$vs.loading.close();

            this.$store.dispatch("address/store", {
              ...this.payload,
              id: response.data.data.address.id
            });

            // PostHog: address_saved
            try {
              const { trackEvent } = await import("@/services/posthog");
              trackEvent("address_saved", {
                country: this.payload.country,
                state: this.payload.state,
                city: this.payload.city,
                has_postalcode: Boolean(this.payload.postalcode),
                is_edit_mode: this.onEditMode(),
              });
            } catch (_) {}

          if (this.onEditMode()) {
            this.$router.push({
              name: "dashboard-profile-detail"
            });
            return;
          }

            await this.$store.dispatch("step/completeStep");

            await this.$store.dispatch("step/incrementCurrentStep");

            const { path } = this.$store.getters["step/current"];

            const { params } = this.$router.history.current;

            this.$router.push({
              name: path,
              params
            });
            return;
          })
          .catch(() => {
            this.$vs.loading.close();
          });
        return;
      }
    },

    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },

    doCaclulateProgress(e) {
      this.calculateProgress({ field: e.target.name, value: e.target.value });
    },

    searchCEP(e) {
      if (e.target.value.length !== 9) {
        this.autocomplete = false;
        return;
      } 
      
      this.$vs.loading({
        text: "Buscando..."
      });
      this.$viaCep
        .buscarCep(e.target.value)
        .then(this.autoCompleteAddress)
        .then(response => {
          this.$vs.loading.close();

          this.payload = {
            ...this.payload,
            country: "Brasil",
            city: response.localidade,
            state: response.uf,
            address: response.logradouro,
            autocomplete: true,
            address_complement: response.complemento,
            address_neighborhood: response.bairro
          };
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "danger",
            title: "Falha ao localizar CEP",
            text:
              "Ocorreu uma falha ao localizar o CEP, por favor tente novamente!"
          });
        });
    },

    doAutoCompleteCalculateProgress(data) {
      Object.keys(data).map(field =>
        this.calculateProgress({ field, value: data[field] })
      );
    },

    googleAnalytics() {
      const { company_label, vacancy_id } = this.$router.history.current.params;

      company_label && vacancy_id
        ? this.$ga.page(`${company_label}/${vacancy_id}/step/address`)
        : this.$ga.page(`${company_label}/step/address`);
    },

    fetchAddress() {
      this.$vs.loading({
        text: "Carregando..."
      });

      const { company_label } = this.$router.history.current.params;

      this.$http
        .get(`api/v1/talent/${company_label}/user/talent?step=address`)
        .then(response => {
          this.$vs.loading.close();
          const { address } = response.data.data;

          this.payload = {
            ...this.payload,
            ...address,
            autocomplete:
              address.autocomplete === null ? false : address.autocomplete
          };
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    ...mapActions("address", [
      "autoCompleteAddress",
      "updateField",
      "setAddress"
    ]),
    ...mapActions("progress", ["calculateProgress"])
  },
  components: {
    ModelSelect,
    ForwardButton,
    BackwardButton,
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";
</style>


<style lang="scss">
.vs-input.isFocus {
  .vs-con-input {
    .vs-input--placeholder {
      display: none;
    }
  }
}
</style>
